<!--
* 组件名 : 新闻图片
* 开发者 : JY
*
* 参数:
*   newsPicture     { Object } -  新闻图片数据
*
* 事件: null
*
*
-->

<template>
  <div class="v-news-picture">
    <h3 class="type-title">{{ newsPicture.description }}</h3>
    <div
      v-for="(item, i) in newsPicture.data"
      :key="i"
      :class="['picture-item d-flex', i % 2 ? 'plural' : '']"
    >
      <div class="left-box">
        <div class="news-desc" v-html="item.description"></div>
      </div>
      <div class="right-box">
        <div class="news-img">
          <img :src="change_path(item.poster)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { i18n } from "@/utils/util";
export default {
  name: "news-picture",
  props: {
    newsPicture: {
      type: Object,
      required: true,
    },
  },

  methods: {
    //  转换为 i18n 图
    change_path(img) {
      return i18n(
        `images/spread-of-kingdom-gospel/${this.$route.name}/news/${img}`
      );
    },
  },
};
</script>

<style lang="scss">
.v-news-picture {
  margin: 0 auto;
  padding-top: 110px;
  width: 1100px;
  overflow: hidden;

  .type-title {
    margin-bottom: 105px;
  }

  .picture-item {
    margin-bottom: 144px;

    &.plural {
      .left-box {
        order: 2;
        margin-left: 7.19%;
      }

      .right-box {
        order: 1;
        margin-right: 7.19%;
      }
    }

    &:not(.plural) {
      .left-box {
        margin-right: 7.19%;
      }

      .right-box {
        margin-left: 7.19%;
      }
    }

    .left-box,
    .right-box {
      width: 42.81%;
      flex-shrink: 0;

      img {
        max-width: 100%;
      }
    }

    .news-img {
      position: relative;
      width: 100%;
      padding-top: 66.67%;
      overflow: hidden;
      border-radius: 8px;

      img {
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    .news-desc {
      height: 100%;
      display: flex;
      align-items: center;
      font-size: 20px;
      line-height: 1.6;
    }
  }

  @media (min-width: $lx-min) {
    width: 1210px;
  }
}
</style>
